import { render } from "./PostComments.vue?vue&type=template&id=19c4be72"
import script from "./PostComments.vue?vue&type=script&lang=js"
export * from "./PostComments.vue?vue&type=script&lang=js"

import "./PostComments.vue?vue&type=style&index=0&id=19c4be72&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__